import { axios } from 'lib/axios';

export const verifySMSOTPLogin = async (data) => {
  return await axios.patch('/user/sms/verifyCode', data);
};
